import { mapValues } from 'lodash-es';

const encodeId = (id: unknown) => encodeURIComponent(id as string);

const encodeIdsMap = (ids: Record<string, unknown>): Record<string, string> =>
  mapValues(ids, encodeId);

export { encodeId, encodeIdsMap };
